import type { Cin7ProductSummary } from "@/api/dtos";
import type { ProductSummary } from "@/api/product/_models/Product";
import { productStatusFromCin7, productTypeFromCin7 } from "./utils";

export const toProductSummaryFromCin7ProductSummary = (
  dto: Cin7ProductSummary,
): ProductSummary => {
  return {
    id: dto.ID,
    sku: dto.SKU,
    name: dto.Name,
    category: dto.Category,
    type: productTypeFromCin7(dto.Type),
    status: productStatusFromCin7(dto.Status),
    pricing: {
      tier1: dto.PriceTier1,
      averageCost: dto.AverageCost,
    },
  };
};
